module.exports = __webpack_public_path__ + "img/logoauth.0f78a892.png";